<template>
  <div class="numeric-locale-switcher">
    <div class="label">
      {{ $t('navBar.numbers') }}
    </div>
    <LocaleSelect
      :model-value="currentNumericLocale"
      :items="availableFormats"
      item-title="format"
      item-value="locale"
      @update:model-value="setLocale"
    />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useContextStore } from '@/stores/context';

const context = useContextStore();
const currentNumericLocale = ref(context.getCurrentNumericLocale);

const availableFormats = computed(() => {
  return context.getAvailableNumericLocales;
});

const setLocale = locale => {
  currentNumericLocale.value = locale;
  context.setNumericLocale({ locale });
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 1.2rem;
  font-weight: normal;
  min-width: 6.1rem;
}

.numeric-locale-switcher {
  display: flex;
  align-items: center;
}
</style>
